import { SR_API_ACTION_APARTMENT_LOCATOR_TOGGLE_LEADS_ENABLED } from 'api/actionTypes';
import { APARTMENT_LOCATOR_TOGGLE_LEADS_SOURCE_LOCATOR_PROFILE } from 'common/leadConstants';

export default async function toggleApartmentLeadsEnabled(
  { state, apiClient },
  { userId, apartmentLeadsEnabled },
) {
  await apiClient.postWithState({
    action: SR_API_ACTION_APARTMENT_LOCATOR_TOGGLE_LEADS_ENABLED,
    queryId: String(userId),
    state: state,
    payload: {
      userId,
      apartmentLeadsEnabled,
      source: APARTMENT_LOCATOR_TOGGLE_LEADS_SOURCE_LOCATOR_PROFILE,
    },
    onSuccess() {
      state.set(['currentUser', 'apartmentLeadsEnabled'], apartmentLeadsEnabled);
    },
  });
}
